import {FC} from "react";

export type IconName =
	| "noForget"
	| "personalized"
	| "reminders"
	| "offices"
	| "overview"
	| "czech"
	| "check";

interface IconProps {
	name: IconName;
	className?: string;
}

const paths: Record<IconName, JSX.Element> = {
	noForget: (
		<>
			<path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
			<path d="M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z" />
			<path d="m9 14 2 2 4-4" />
		</>
	),
	personalized: (
		<>
			<path d="M20 21a8 8 0 0 0-16 0" />
			<circle cx="12" cy="7" r="4" />
		</>
	),
	reminders: (
		<>
			<path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
			<path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
		</>
	),
	offices: (
		<>
			<path d="M3 21h18" />
			<path d="m5 21 .5-11h13l.5 11" />
			<path d="M4 10 12 4l8 6" />
			<path d="M10 21v-5h4v5" />
		</>
	),
	overview: (
		<>
			<path d="M3 3v18h18" />
			<path d="m7 15 3-4 3 2 4-6" />
		</>
	),
	czech: (
		<>
			<path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" />
			<path d="M3.5 9h17M3.5 15h17" />
			<path d="M12 3a14 14 0 0 1 0 18 14 14 0 0 1 0-18z" />
		</>
	),
	check: <path d="m5 12 5 5 9-11" />,
};

export const Icon: FC<IconProps> = ({name, className}) => (
	<svg
		className={className}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.75"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		{paths[name]}
	</svg>
);
